import axios from 'axios';
import Qs from 'qs';

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	paramsSerializer: (params) =>
		Qs.stringify(params, {
			arrayFormat: 'brackets',
		}),
});

export default axiosInstance;